import script from "./AttributeLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributeLabel.vue?vue&type=script&setup=true&lang=ts"

import "./AttributeLabel.vue?vue&type=style&index=0&id=06317384&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06317384"]])

export default __exports__